import React from "react";
import FlowRunnerCore from "../flow/FlowRunnerCore";

/**
 * Sliding drawer at the top of the center panel that runs a flow inline.
 *
 * Props:
 *   centerFlow    – string | null  (flow name; null = closed)
 *   activeFlowObj – flow object | null
 *   token         – Bearer token string
 *   onClose       – () => void
 *   onResults     – (results) => void
 *   onClear       – () => void
 *   t             – i18next translation function
 */
export default function FlowDrawer({
  centerFlow,
  activeFlowObj,
  token,
  onClose,
  onResults,
  onClear,
  t,
}) {
  return (
    <div
      className={`flow-drawer ${centerFlow ? "open" : ""}`}
      aria-hidden={!centerFlow}
    >
      <div className="flow-drawer-header">
        <div style={{ fontWeight: 700 }}>
          {activeFlowObj?.name || t("results.flow")}
        </div>
        <button
          className="drawer-close-btn"
          onClick={onClose}
          type="button"
          aria-label={t("common.close")}
          title={t("common.close")}
        >
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            aria-hidden="true"
          >
            <line
              x1="1"
              y1="1"
              x2="7"
              y2="7"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
            />
            <line
              x1="7"
              y1="1"
              x2="1"
              y2="7"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>
      <div className="flow-drawer-body">
        {centerFlow && (
          <FlowRunnerCore
            flow={activeFlowObj || undefined}
            initialFlowName={centerFlow}
            token={token}
            onClose={onClose}
            showHeader={false}
            showContextPanel={false}
            onResults={onResults}
            onClear={onClear}
          />
        )}
      </div>
    </div>
  );
}
